<div class="custom-dialog">
  <h2 mat-dialog-title>
    <span>CONTACT SUPPORT TEAM</span>
    <button type="button" class="primary-btn link" mat-dialog-close>
      <span class="material-icons mr-1"> close </span> Close
    </button>
  </h2>

  <mat-dialog-content class="support-form__cont">
    <form
      class="support-form"
      [formGroup]="supportForm"
      (ngSubmit)="submitSupportForm()">
      <div fxLayout="row">
        <div fxFlex="40">
          <mat-form-field class="custom-form-control required">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" tabindex="0" />
          </mat-form-field>
          <div
            *ngIf="userFirstName.invalid && userFirstName.dirty"
            class="mb-1">
            <span class="error-msg" *ngIf="userFirstName.errors?.['minlength']">
              First Name must have at least 3 characters.
            </span>
            <span class="error-msg" *ngIf="userFirstName.errors?.['maxlength']">
              First Name exceeding 40 characters.
            </span>
            <span
              class="error-msg"
              *ngIf="supportForm.controls['firstName'].hasError('pattern')">
              Alphabets and following special characters, ".","'","-" are
              allowed.
            </span>
          </div>
          <mat-form-field class="custom-form-control required">
            <mat-label>Last Name </mat-label>
            <input matInput formControlName="lastName" tabindex="0" />
          </mat-form-field>
          <div *ngIf="userLastName.invalid && userLastName.dirty" class="mb-1">
            <span class="error-msg" *ngIf="userLastName.errors?.['minlength']">
              Last Name must have at least 3 characters.
            </span>
            <span class="error-msg" *ngIf="userLastName.errors?.['maxlength']">
              Last Name exceeding 40 characters.
            </span>
            <span
              class="error-msg"
              *ngIf="supportForm.controls['lastName'].hasError('pattern')">
              Alphabets and following special characters, ".","'","-" are
              allowed.
            </span>
          </div>
          <div class="mobile-field">
            <div class="prefix">(+001)</div>
            <mat-form-field class="custom-form-control required">
              <mat-label>Mobile Number </mat-label>
              <input
                matInput
                type="text"
                formControlName="contact"
                tabindex="0" />
            </mat-form-field>
          </div>
          <span
            class="error-msg mb-1"
            *ngIf="
              (supportForm.controls['contact'].dirty &&
                (supportForm.controls['contact'].hasError('minlength') ||
                  supportForm.controls['contact'].hasError('maxlength'))) ||
              supportForm.controls['contact'].hasError('pattern')
            ">
            Invalid Mobile number.
          </span>
          <mat-form-field class="custom-form-control required">
            <mat-label>Email Address </mat-label>
            <input matInput formControlName="email" tabindex="0" />
          </mat-form-field>
          <span
            class="error-msg mb-1"
            *ngIf="
              supportForm.controls['email'].dirty &&
              supportForm.controls['email'].invalid &&
              supportForm.controls['email'].hasError('pattern')
            ">
            Invalid email id.
          </span>
        </div>
      </div>
      <div fxLayout="row">
        <div fxFlex="50">
          <mat-form-field class="custom-form-control">
            <mat-label>Message</mat-label>
            <textarea matInput formControlName="mesage" tabindex="0"></textarea>
            <mat-hint align="end"> {{ userMessage?.length }} / 1000</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <mat-dialog-actions align="end">
        <button
          type="button"
          class="primary-btn link pa-0 mr-10"
          mat-dialog-close>
          Cancel
        </button>
        <button
          type="submit"
          class="primary-btn"
          [disabled]="
            supportForm.controls['email'].invalid || userEmail.value === ''
          ">
          Submit
          <div *ngIf="isLoading" class="spinner ml-1">
            <mat-spinner [diameter]="20"></mat-spinner>
          </div>
        </button>
      </mat-dialog-actions>
    </form>
  </mat-dialog-content>
</div>
